import { SpotifyService } from './spotify.service';

export default SpotifyService;
